import { z } from 'zod'

export const trainerAffiliatePayoutExceptionResponseSchema = z.record(z.unknown())
export type TrainerAffiliatePayoutExceptionResponse = z.infer<typeof trainerAffiliatePayoutExceptionResponseSchema>
